export default {
  en: {
    timeR: 'Count down: ',
    copyright: 'The copyright of this event belongs to App',
    plsSelectPic: 'Please choose a photo to upload',
    plsSelectType: 'Please select question type',
    exceeds: 'Word count meets limitation',
    placeholder: 'Please describe your request briefly',
    maxPic: 'Photo/video selected cannot exceed 4',
    uploadPicFail: 'Photo upload failed',
    submitFail: 'Feedback submit failed',
    nav1: 'Feedback',
    nav2: 'My',
    issues: 'Hot issues',
    Recharge: 'Recharge problem',
    Accounts: 'Accounts & settings',
    Other: 'Other issues',
    Feedback: 'Feedback',
    qApp: 'APP problem',
    qSuggest: 'Suggestion',
    qRecharge: 'Room and members',
    qOther: 'Other',
    des: 'Request description',
    order: 'Order',
    snap: 'Photo/Video (optional)',
    submitF: 'Submit feedback',
    submitR: 'Submit report',
    reply: 'Request response',
    score: 'Rate the service',
    submit: 'Submit',
    thanks: 'Thank you for your feedback',
    thanksC: 'We will reply within 24 hours. Please check the reply in "My feedback"',
    sure: 'Confirm',
    title: 'FAQ & Feedback',
    ordersnap: 'Order screenshot/video',
    noTransactionId: 'Please fill in order number',
    sec30: 'Only video within 30 seconds can be uploaded.',
    noReply:
      'Thank you for your feedback！We will reply as soon as possible. Please pay attention to the message notification.',
    hasReply: 'Replied',
    score5: 'Very good',
    score4: 'Good',
    score3: 'Not bad',
    score2: 'Bad',
    score1: 'Very bad',
    success: 'Thank you for your feedback',
    fail: 'Submit failed',
    pleaseScore: 'Please rate the service',
    nofeedback: 'No feedback yet',
    invalid: 'Thank you for your feedback, we will continue to improve and hope you have a good time!',
    serviceHelp: 'If you have questions, please click here to contact customer service.',

    reportTxt: 'Report',
    curseTxt: 'Curse',
    pornographyTxt: 'Pornography/Child Protection',
    advertiseTxt: 'Advertise',
    Unsa: 'Illegal User Name / Signature / Avatar',
    Rnsa: 'Illegal Room Name / Signature / Avatar',
    fbR: 'Feedback',
    rpR: 'Report',

    operate: 'Operational problems',
    roomP: 'Room problems',
    fr: 'Feedback & Report',

    picDesc: 'Feedback Picture',
    leaveInfo: 'Please enter your WhatsApp, phone number, or email'
  },
  zh: {
    timeR: 'Count down: ',
    copyright: 'The copyright of this event belongs to App',
    plsSelectPic: 'Please choose a photo to upload',
    plsSelectType: 'Please select question type',
    exceeds: 'Word count meets limitation',
    placeholder: 'Please describe your request briefly',
    maxPic: 'Photo/video selected cannot exceed 4',
    uploadPicFail: 'Photo upload failed',
    submitFail: 'Feedback submit failed',
    nav1: 'Feedback',
    nav2: 'My',
    issues: 'Hot issues',
    Recharge: 'Recharge problem',
    Accounts: 'Accounts & settings',
    Other: 'Other issues',
    Feedback: 'Feedback',
    qApp: 'APP problem',
    qSuggest: 'Suggestion',
    qRecharge: 'Room and members',
    qOther: 'Other',
    des: 'Request description',
    order: 'Order',
    snap: 'Photo/Video (optional)',
    submitF: 'Submit feedback',
    submitR: 'Submit report',
    reply: 'Request response',
    score: 'Rate the service',
    submit: 'Submit',
    thanks: 'Thank you for your feedback',
    thanksC: 'We will reply within 24 hours. Please check the reply in "My feedback"',
    sure: 'Confirm',
    title: 'FAQ & Feedback',
    ordersnap: 'Order screenshot/video',
    noTransactionId: 'Please fill in order number',
    sec30: 'Only video within 30 seconds can be uploaded.',
    noReply:
      'Thank you for your feedback！We will reply as soon as possible. Please pay attention to the message notification.',
    hasReply: 'Replied',
    score5: 'Very good',
    score4: 'Good',
    score3: 'Not bad',
    score2: 'Bad',
    score1: 'Very bad',
    success: 'Thank you for your feedback',
    fail: 'Submit failed',
    pleaseScore: 'Please rate the service',
    nofeedback: 'No feedback yet',
    invalid: 'Thank you for your feedback, we will continue to improve and hope you have a good time!',
    serviceHelp: 'If you have questions, please click here to contact customer service.',

    reportTxt: 'Report',
    curseTxt: 'Curse',
    pornographyTxt: 'Pornography/Child Protection',
    advertiseTxt: 'Advertise',
    Unsa: 'Illegal User Name / Signature / Avatar',
    Rnsa: 'Illegal Room Name / Signature / Avatar',
    fbR: 'Feedback',
    rpR: 'Report',

    operate: 'Operational problems',
    roomP: 'Room problems',
    fr: 'Feedback & Report',

    picDesc: 'Feedback Picture',
    leaveInfo: 'Please enter your WhatsApp, phone number, or email'
  },
  ar: {
    timeR: 'العد التنازلي ',
    copyright: 'The copyright of this event belongs to App',
    plsSelectPic: 'الرجاء تحديد الصورة التي تريد تحميلها',
    plsSelectType: 'الرجاء تحديد نوع المشكلة',
    exceeds: 'يصل عدد الكلمات إلى الحد الأقصى',
    placeholder: 'وصف المشكالة التي تريد إبلاغ عنها ببسيط',
    maxPic: 'لا يمكن أن تتجاوز الصور / مقاطع الفيديو المحددة 4',
    uploadPicFail: 'فشل تحميل الصورة',
    submitFail: 'فشل في إرسال التقييم',
    nav1: 'التقييم',
    // nav2: 'تقييمي',
    nav2: 'لي',
    issues: 'مشكلة ساخنة',
    Recharge: 'مشكلة الشحن',
    Accounts: 'الحسابات والإعدادات',
    Other: 'المشاكل الأخرى',
    Feedback: 'التقييم',
    qApp: 'مشكلة التطبيق',
    qSuggest: 'اقتراح',
    qRecharge: 'الغرفة وألاعضاء',
    qOther: 'الأخر',
    des: 'وصف المشكلة',
    order: 'طلب الشحن',
    snap: 'الصورة/ الفيديو(تعبئة اختيارية)',
    submitF: 'تقديم التقييم',
    submitR: 'إرسال التقرير',
    reply: 'الرد على السؤال',
    score: 'خدمات التعليق',
    submit: 'تقديم',
    thanks: 'شكرا على تقييمكم',
    thanksC: '."سنرد في غضون 24 ساعة، يرجى التحقق من رده في "ملاحظاتي',
    sure: 'تأكيد',
    title: 'ردود الفعل & & تقرير',
    ordersnap: 'لقطة شاشة/فيديو للطلب',
    noTransactionId: 'يرجى ملء رقم الطلب',
    sec30: '.يمكن تحميل الفيديو فقط في غضون 30 ثانية',
    noReply: '.شكرا على تقييمكم سنعود عليكم في أسرع الوقت،رجاء الانتباه بالأخبار',
    hasReply: 'تم الرد',
    score5: 'جيد جدا',
    score4: 'جيد',
    score3: 'متوسط',
    score2: 'سيء',
    score1: 'سيء جدا',
    success: 'شكرا على تقييمكم',
    fail: 'فشل التقديم',
    pleaseScore: 'يرجى نقد الخدمة',
    nofeedback: 'لا يوجد تقييم',
    invalid: 'شكرًا لك على تعليقاتك ، سنواصل التحسن ونأمل أن تقضي وقتًا ممتعًا!',
    serviceHelp: 'إذا كانت لديك اي مشكله  ، يرجى النقر هنا للتواصل مع خدمة العملاء أحلام ',

    reportTxt: 'إبلاغ ',
    curseTxt: 'الشتم',
    pornographyTxt: 'المواد الإباحية/حماية الطفل',
    advertiseTxt: 'الاعلان',
    Unsa: 'اسم المستخدم ، التوقيع ، الصورة ',
    Rnsa: 'اسم الغرفة ، توقيع الغرفة ، الصورة  للغرفة',
    fbR: 'تغذية راجعة',
    rpR: 'أبلغ عن',

    operate: 'مشاكل تشغيلية',
    roomP: 'مشاكل الغرفة',
    fr: 'ردود الفعل & & تقرير',

    picDesc: 'صورة ردود الفعل',
    leaveInfo: 'يرجى إدخال رقم الواتساب أو رقم الهاتف أو البريد الإلكتروني الخاص بك'
  },
  tr: {
    timeR: 'Kalan süre: ',
    copyright: 'The copyright of this event belongs to App',
    plsSelectPic: 'Lütfen yüklemek istediğiniz resmi seçin',
    plsSelectType: 'Lütfen sorun türü seçin',
    exceeds: 'Kelime sayısı limitine ulaştı',
    placeholder: 'Geri bildirmek istediğiniz sorunu açıklayın',
    maxPic: 'En çok 4 resim/video seçebilirsiniz',
    uploadPicFail: 'Resim yükleme başarısız',
    submitFail: 'Geri bildirim başarısız',
    nav1: 'Geri bildirim',
    // nav2: 'Geri bildirimim',
    nav2: 'Benim',
    issues: 'Sık konular',
    Recharge: 'Çekim yama sorunu',
    Accounts: 'Hesaplar & ayarlar',
    Other: 'Diğer konular',
    Feedback: 'Geri bildirim',
    qApp: 'Uygulama sorunları',
    qSuggest: 'Öneri',
    qRecharge: 'Oda ve üye',
    qOther: 'Diğer',
    des: 'Sorun açıklaması',
    order: 'Sipariş',
    snap: 'ss/video (isteğe bağlı)',
    submitF: 'Gönder',
    submitR: 'Rapor gönder',
    reply: 'Sorunun cevabı',
    score: 'Hizmetleri yorumla',
    submit: 'Gönder',
    thanks: 'Geri bildiriminiz için teşekkür ederiz',
    thanksC: '24 saat içinde cevap vereceğiz. Lütfen "Geri bildirimim" kısmından cevabını kontrol edin',
    sure: 'Onayla',
    title: 'Geribildirim & Rapor',
    ordersnap: 'Sipariş ss/video',
    noTransactionId: 'Lütfen sipariş numaranızı yazın',
    sec30: '30 s üzerindeki video yüklenemez.',
    noReply:
      'Geri bildiriminiz için teşekkür ederiz! En kısa sürede size cevap vereceğiz. Mesajlarınızı kontrol etmeyi unutmayın.',
    hasReply: 'Cevaplandı',
    score5: 'Çok güzel',
    score4: 'Güzel',
    score3: 'Normal',
    score2: 'Kötü',
    score1: 'Çok kötü',
    success: 'Geri bildiriminiz için teşekkür ederiz.',
    fail: 'Gönderme başarısız',
    pleaseScore: 'Lütfen hizmetleri yorumlayın',
    nofeedback: 'Geri bildirim yok',
    invalid: 'Geri bildiriminiz için teşekkür ederiz, geliştirmeye devam edeceğiz ve iyi vakit geçirmenizi umuyoruz!',
    serviceHelp: 'Sorularınız varsa lütfen servisle iletişime geçmek için buraya tıklayın',

    reportTxt: 'Bildiri',
    curseTxt: 'küfür',
    pornographyTxt: 'Pornografi/Çocuk Koruma',
    advertiseTxt: 'reklam yapmak',
    Unsa: 'Kullanıcı adı, imza, avatar',
    Rnsa: 'Oda adı, oda imzası, oda avatarı',
    fbR: 'geri bildirim',
    rpR: 'bildiri',

    operate: 'Operasyonel problemler',
    roomP: 'Oda problemleri',
    fr: 'Geribildirim & Rapor',

    picDesc: 'Geri bildirim resmi',
    leaveInfo: 'Lütfen WhatsAPP,Telefon Numarası Veya e-mail Girin'
  },
  pt: {
    timeR: 'Contagem regressiva: ',
    copyright: 'Os direitos autorais deste evento pertencem ao App',
    plsSelectPic: 'Por favor, escolha uma foto para enviar',
    plsSelectType: 'Por favor, selecione o tipo de pergunta',
    exceeds: 'A contagem de palavras atingiu o limite',
    placeholder: 'Por favor, descreva sua solicitação brevemente',
    maxPic: 'A foto/vídeo selecionado não pode exceder 4',
    uploadPicFail: 'Falha no envio da foto',
    submitFail: 'Falha no envio do feedback',
    nav1: 'Feedback',
    nav2: 'Meu',
    issues: 'Questões quentes',
    Recharge: 'Problema de recarga',
    Accounts: 'Contas e configurações',
    Other: 'Outras questões',
    Feedback: 'Feedback',
    qApp: 'Problema com o APP',
    qSuggest: 'Sugestão',
    qRecharge: 'Sala e membros',
    qOther: 'Outro',
    des: 'Descrição da solicitação',
    order: 'Pedido',
    snap: 'Foto/Vídeo (opcional)',
    submitF: 'Enviar feedback',
    submitR: 'Enviar relatório',
    reply: 'Resposta da solicitação',
    score: 'Avaliar o serviço',
    submit: 'Enviar',
    thanks: 'Obrigado pelo seu feedback',
    thanksC: 'Responderemos em até 24 horas. Verifique a resposta em "Meu feedback"',
    sure: 'Confirmar',
    title: 'Perguntas frequentes & Feedback',
    ordersnap: 'Captura de tela/vídeo do pedido',
    noTransactionId: 'Por favor, preencha o número do pedido',
    sec30: 'Somente vídeos com até 30 segundos podem ser enviados.',
    noReply:
      'Obrigado pelo seu feedback! Respondemos o mais rápido possível. Fique atento às notificações de mensagens.',
    hasReply: 'Respondido',
    score5: 'Muito bom',
    score4: 'Bom',
    score3: 'Nada mal',
    score2: 'Ruim',
    score1: 'Muito ruim',
    success: 'Obrigado pelo seu feedback',
    fail: 'Falha no envio',
    pleaseScore: 'Por favor, avalie o serviço',
    nofeedback: 'Ainda sem feedback',
    invalid: 'Obrigado pelo seu feedback, continuaremos a melhorar e esperamos que você tenha uma boa experiência!',
    serviceHelp: 'Se você tiver dúvidas, clique aqui para entrar em contato com o suporte ao cliente.',
    reportTxt: 'Denúncia',
    curseTxt: 'Xingamento',
    pornographyTxt: 'Pornografia/Proteção Infantil',
    advertiseTxt: 'Publicidade',
    Unsa: 'Nome de usuário/Assinatura/Avatar ilegal',
    Rnsa: 'Nome da sala/Assinatura/Avatar ilegal',
    fbR: 'Feedback',
    rpR: 'Relatar',
    operate: 'Problemas operacionais',
    roomP: 'Problemas na sala',
    fr: 'Feedback & Relatar',
    picDesc: 'Imagem de feedback',
    leaveInfo: 'Por favor, insira seu WhatsApp, número de telefone ou e-mail'
  },
  id: {
    timeR: 'Hitung mundur: ',
    copyright: 'Hak cipta acara ini milik App',
    plsSelectPic: 'Silakan pilih foto untuk diunggah',
    plsSelectType: 'Silakan pilih jenis pertanyaan',
    exceeds: 'Jumlah kata memenuhi batasan',
    placeholder: 'Harap jelaskan permintaan Anda secara singkat',
    maxPic: 'Foto/video yang dipilih tidak boleh lebih dari 4',
    uploadPicFail: 'Unggah foto gagal',
    submitFail: 'Pengiriman umpan balik gagal',
    nav1: 'Umpan balik',
    nav2: 'Saya',
    issues: 'Masalah panas',
    Recharge: 'Masalah pengisian ulang',
    Accounts: 'Akun & pengaturan',
    Other: 'Masalah lain',
    Feedback: 'Umpan balik',
    qApp: 'Masalah APP',
    qSuggest: 'Saran',
    qRecharge: 'Ruangan dan anggota',
    qOther: 'Lainnya',
    des: 'Deskripsi permintaan',
    order: 'Pesanan',
    snap: 'Foto/Video (opsional)',
    submitF: 'Kirim umpan balik',
    submitR: 'Kirim laporan',
    reply: 'Respon permintaan',
    score: 'Beri penilaian pada layanan',
    submit: 'Kirim',
    thanks: 'Terima kasih atas umpan balik Anda',
    thanksC: 'Kami akan membalas dalam 24 jam. Silakan cek balasan di "Umpan balik saya"',
    sure: 'Konfirmasi',
    title: 'FAQ & Umpan Balik',
    ordersnap: 'Screenshot/video pesanan',
    noTransactionId: 'Silakan isi nomor pesanan',
    sec30: 'Hanya video dalam 30 detik yang dapat diunggah.',
    noReply: 'Terima kasih atas umpan balik Anda! Kami akan membalas secepatnya. Harap perhatikan pemberitahuan pesan.',
    hasReply: 'Dibalas',
    score5: 'Sangat baik',
    score4: 'Baik',
    score3: 'Tidak buruk',
    score2: 'Buruk',
    score1: 'Sangat buruk',
    success: 'Terima kasih atas umpan balik Anda',
    fail: 'Pengiriman gagal',
    pleaseScore: 'Harap beri penilaian pada layanan',
    nofeedback: 'Belum ada umpan balik',
    invalid: 'Terima kasih atas umpan balik Anda, kami akan terus memperbaiki dan berharap Anda menikmati waktu Anda!',
    serviceHelp: 'Jika Anda memiliki pertanyaan, silakan klik di sini untuk menghubungi layanan pelanggan.',

    reportTxt: 'Laporan',
    curseTxt: 'Kata-kata kotor',
    pornographyTxt: 'Pornografi/Perlindungan Anak',
    advertiseTxt: 'Iklan',
    Unsa: 'Nama Pengguna / Tanda Tangan / Avatar Ilegal',
    Rnsa: 'Nama Ruangan / Tanda Tangan / Avatar Ilegal',
    fbR: 'Umpan Balik',
    rpR: 'Laporan',

    operate: 'Masalah operasional',
    roomP: 'Masalah ruangan',
    fr: 'Umpan Balik & Laporan',

    picDesc: 'Gambar Umpan Balik',
    leaveInfo: 'Silakan masukkan WhatsApp, nomor telepon, atau email Anda'
  },
  uz: {
    timeR: 'Taymer: ',
    copyright: 'Ushbu tadbirning mualliflik huquqi App ga tegishli',
    plsSelectPic: 'Iltimos, yuklash uchun rasm tanlang',
    plsSelectType: 'Iltimos, savol turini tanlang',
    exceeds: "So'zlar soni chegarani oshdi",
    placeholder: "Iltimos, so'rovingizni qisqacha bayon eting",
    maxPic: 'Tanlangan rasm/video 4 tadan oshmasligi kerak',
    uploadPicFail: 'Rasmni yuklashda xatolik yuz berdi',
    submitFail: 'Fikr yuborishda xatolik yuz berdi',
    nav1: 'Fikrlar',
    nav2: 'Mening',
    issues: 'Oqilmas masalalar',
    Recharge: "To'lov muammosi",
    Accounts: 'Hisoblar va sozlamalar',
    Other: 'Boshqa muammolar',
    Feedback: 'Fikrlar',
    qApp: 'Ilova muammosi',
    qSuggest: 'Taklif',
    qRecharge: "Xonalar va a'zolar",
    qOther: 'Boshqa',
    des: "So'rov ta'rifi",
    order: 'Buyurtma',
    snap: 'Rasm/Video (ixtiyoriy)',
    submitF: 'Fikrni yuborish',
    submitR: 'Hisobotni yuborish',
    reply: "So'rovga javob",
    score: 'Xizmatni baholang',
    submit: 'Yuborish',
    thanks: 'Fikringiz uchun rahmat',
    thanksC: '24 soat ichida javob beramiz. Javobni "Mening fikrlarim" bo\'limidan tekshiring',
    sure: 'Tasdiqlash',
    title: 'FAQ va Fikrlar',
    ordersnap: 'Buyurtma skrinshoti/video',
    noTransactionId: 'Buyurtma raqamini kiriting',
    sec30: 'Faqat 30 soniya ichidagi videolarni yuklash mumkin.',
    noReply: 'Fikringiz uchun rahmat! Biz tez orada javob beramiz. Iltimos, xabar bildirishini kuzatib boring.',
    hasReply: 'Javob berildi',
    score5: 'Juda yaxshi',
    score4: 'Yaxshi',
    score3: 'Yaxshi emas',
    score2: 'Yomon',
    score1: 'Juda yomon',
    success: 'Fikringiz uchun rahmat',
    fail: "Yuborish muvaffaqiyatsiz bo'ldi",
    pleaseScore: 'Iltimos, xizmatni baholang',
    nofeedback: 'Hali fikr bildirilmagan',
    invalid: 'Fikringiz uchun rahmat, biz yanada yaxshilanishni davom ettiramiz va sizga yaxshi vaqt tilaymiz!',
    serviceHelp: "Agar savollaringiz bo'lsa, iltimos, mijozlarni qo'llab-quvvatlashga murojaat qiling.",
    reportTxt: 'Xabar berish',
    curseTxt: 'Lanat',
    pornographyTxt: 'Pornografiya/ Bolalar himoyasi',
    advertiseTxt: 'Reklama',
    Unsa: 'Qonunsiz foydalanuvchi ismi / imzo / avatar',
    Rnsa: 'Qonunsiz xona ismi / imzo / avatar',
    fbR: 'Fikr',
    rpR: 'Xabar',
    operate: 'Amaliyot muammolari',
    roomP: 'Xona muammolari',
    fr: 'Fikrlar & Xabarlar',
    picDesc: 'Fikr rasmi',
    leaveInfo: 'Iltimos, WhatsApp raqamingizni, telefon raqamingizni yoki elektron pochtangizni kiriting'
  },
  ru: {
    timeR: 'Обратный отсчет: ',
    copyright: 'Авторские права на это мероприятие принадлежат App',
    plsSelectPic: 'Пожалуйста, выберите фотографию для загрузки',
    plsSelectType: 'Пожалуйста, выберите тип вопроса',
    exceeds: 'Количество слов превышает лимит',
    placeholder: 'Пожалуйста, кратко опишите ваш запрос',
    maxPic: 'Выбранные фото/видео не могут превышать 4',
    uploadPicFail: 'Ошибка загрузки фото',
    submitFail: 'Ошибка отправки отзыва',
    nav1: 'Отзыв',
    nav2: 'Мой',
    issues: 'Популярные вопросы',
    Recharge: 'Проблемы с пополнением',
    Accounts: 'Аккаунты и настройки',
    Other: 'Другие вопросы',
    Feedback: 'Отзыв',
    qApp: 'Проблемы с приложением',
    qSuggest: 'Предложение',
    qRecharge: 'Комнаты и участники',
    qOther: 'Другое',
    des: 'Описание запроса',
    order: 'Заказ',
    snap: 'Фото/Видео (опционально)',
    submitF: 'Отправить отзыв',
    submitR: 'Отправить отчет',
    reply: 'Ответ на запрос',
    score: 'Оцените сервис',
    submit: 'Отправить',
    thanks: 'Спасибо за ваш отзыв',
    thanksC: 'Мы ответим в течение 24 часов. Пожалуйста, проверьте ответ в разделе "Мои отзывы"',
    sure: 'Подтвердить',
    title: 'FAQ и Отзывы',
    ordersnap: 'Скриншот/видео заказа',
    noTransactionId: 'Пожалуйста, укажите номер заказа',
    sec30: 'Можно загрузить только видео длительностью до 30 секунд.',
    noReply: 'Спасибо за ваш отзыв! Мы ответим как можно скорее. Пожалуйста, следите за уведомлениями.',
    hasReply: 'Ответ получен',
    score5: 'Очень хорошо',
    score4: 'Хорошо',
    score3: 'Неплохо',
    score2: 'Плохо',
    score1: 'Очень плохо',
    success: 'Спасибо за ваш отзыв',
    fail: 'Не удалось отправить',
    pleaseScore: 'Пожалуйста, оцените сервис',
    nofeedback: 'Еще нет отзывов',
    invalid: 'Спасибо за ваш отзыв, мы будем продолжать совершенствоваться и надеемся, что вам понравится!',
    serviceHelp: 'Если у вас есть вопросы, пожалуйста, свяжитесь с поддержкой.',
    reportTxt: 'Жалоба',
    curseTxt: 'Оскорбления',
    pornographyTxt: 'Порнография/Защита детей',
    advertiseTxt: 'Реклама',
    Unsa: 'Незаконное имя пользователя / подпись / аватар',
    Rnsa: 'Незаконное имя комнаты / подпись / аватар',
    fbR: 'Отзыв',
    rpR: 'Жалоба',
    operate: 'Операционные проблемы',
    roomP: 'Проблемы с комнатой',
    fr: 'Отзывы и жалобы',
    picDesc: 'Изображение отзыва',
    leaveInfo: 'Пожалуйста, введите ваш WhatsApp, телефон или электронную почту'
  },
  fa: {
    timeR: 'شمارش معکوس: ',
    copyright: 'حق چاپ این رویداد متعلق به App است',
    plsSelectPic: 'لطفا یک عکس برای بارگذاری انتخاب کنید',
    plsSelectType: 'لطفا نوع سوال را انتخاب کنید',
    exceeds: 'تعداد کلمات از محدودیت بیشتر است',
    placeholder: 'لطفا درخواست خود را به طور مختصر توضیح دهید',
    maxPic: 'عکس/ویدیو انتخاب شده نباید بیشتر از 4 باشد',
    uploadPicFail: 'بارگذاری عکس با خطا مواجه شد',
    submitFail: 'ارسال بازخورد با خطا مواجه شد',
    nav1: 'بازخورد',
    nav2: 'من',
    issues: 'مسائل داغ',
    Recharge: 'مشکل شارژ',
    Accounts: 'حساب‌ها و تنظیمات',
    Other: 'مشکلات دیگر',
    Feedback: 'بازخورد',
    qApp: 'مشکل در برنامه',
    qSuggest: 'پیشنهاد',
    qRecharge: 'اتاق‌ها و اعضا',
    qOther: 'سایر',
    des: 'توضیحات درخواست',
    order: 'سفارش',
    snap: 'عکس/ویدیو (اختیاری)',
    submitF: 'ارسال بازخورد',
    submitR: 'ارسال گزارش',
    reply: 'پاسخ درخواست',
    score: 'امتیازدهی به سرویس',
    submit: 'ارسال',
    thanks: 'از بازخورد شما متشکریم',
    thanksC: 'ما ظرف 24 ساعت پاسخ خواهیم داد. لطفاً پاسخ را در بخش "بازخورد من" بررسی کنید',
    sure: 'تأیید',
    title: 'سؤالات متداول و بازخورد',
    ordersnap: 'اسکرین‌شات/ویدیو سفارش',
    noTransactionId: 'لطفاً شماره سفارش را وارد کنید',
    sec30: 'فقط ویدیوهایی که حداکثر 30 ثانیه طول دارند قابل بارگذاری هستند.',
    noReply: 'از بازخورد شما متشکریم! ما به زودی پاسخ خواهیم داد. لطفاً اعلان‌ها را دنبال کنید.',
    hasReply: 'پاسخ داده شد',
    score5: 'بسیار خوب',
    score4: 'خوب',
    score3: 'بدک نیست',
    score2: 'بد',
    score1: 'بسیار بد',
    success: 'از بازخورد شما متشکریم',
    fail: 'ارسال ناموفق بود',
    pleaseScore: 'لطفاً سرویس را ارزیابی کنید',
    nofeedback: 'هنوز بازخوردی داده نشده است',
    invalid: 'از بازخورد شما متشکریم، ما به بهبود ادامه خواهیم داد و امیدواریم شما از وقت خود لذت ببرید!',
    serviceHelp: 'اگر سوالی دارید، لطفاً برای تماس با پشتیبانی اینجا کلیک کنید.',
    reportTxt: 'گزارش',
    curseTxt: 'ناسزا',
    pornographyTxt: 'پورنوگرافی/حفاظت از کودکان',
    advertiseTxt: 'تبلیغات',
    Unsa: 'نام کاربری/امضا/آواتار غیرقانونی',
    Rnsa: 'نام اتاق/امضا/آواتار غیرقانونی',
    fbR: 'بازخورد',
    rpR: 'گزارش',
    operate: 'مشکلات عملیاتی',
    roomP: 'مشکلات اتاق',
    fr: 'بازخورد و گزارش',
    picDesc: 'تصویر بازخورد',
    leaveInfo: 'لطفاً شماره WhatsApp، شماره تلفن یا ایمیل خود را وارد کنید'
  },
  ur: {
    timeR: 'الٹی گنتی: ',
    copyright: 'اس ایونٹ کے جملہ حقوق ایپ کے پاس محفوظ ہیں',
    plsSelectPic: 'براہ کرم اپ لوڈ کرنے کے لیے ایک تصویر منتخب کریں',
    plsSelectType: 'براہ کرم سوال کی قسم منتخب کریں',
    exceeds: 'لفظوں کی تعداد حد تک پہنچ گئی',
    placeholder: 'براہ کرم اپنی درخواست مختصر طور پر بیان کریں',
    maxPic: 'منتخب کردہ تصویر/ویڈیو 4 سے زیادہ نہیں ہو سکتی',
    uploadPicFail: 'تصویر اپ لوڈ کرنے میں ناکام',
    submitFail: 'فیڈبیک جمع کروانے میں ناکام',
    nav1: 'فیڈبیک',
    nav2: 'میرا',
    issues: 'مشہور مسائل',
    Recharge: 'ریچارج کا مسئلہ',
    Accounts: 'اکاؤنٹس اور ترتیبات',
    Other: 'دیگر مسائل',
    Feedback: 'فیڈبیک',
    qApp: 'ایپ کا مسئلہ',
    qSuggest: 'تجویز',
    qRecharge: 'کمرہ اور ممبران',
    qOther: 'دیگر',
    des: 'درخواست کی تفصیل',
    order: 'آرڈر',
    snap: 'تصویر/ویڈیو (اختیاری)',
    submitF: 'فیڈبیک جمع کروائیں',
    submitR: 'رپورٹ جمع کروائیں',
    reply: 'درخواست کا جواب',
    score: 'سروس کی درجہ بندی کریں',
    submit: 'جمع کروائیں',
    thanks: 'آپ کی فیڈبیک کا شکریہ',
    thanksC: 'ہم 24 گھنٹوں میں جواب دیں گے۔ براہ کرم "میرا فیڈبیک" میں جواب چیک کریں',
    sure: 'تصدیق',
    title: 'اکثر پوچھے گئے سوالات اور فیڈبیک',
    ordersnap: 'آرڈر کا اسکرین شاٹ/ویڈیو',
    noTransactionId: 'براہ کرم آرڈر نمبر درج کریں',
    sec30: 'صرف 30 سیکنڈ کی ویڈیو اپ لوڈ کی جا سکتی ہے۔',
    noReply: 'آپ کی فیڈبیک کا شکریہ! ہم جلد از جلد جواب دیں گے۔ براہ کرم پیغام کی اطلاع پر توجہ دیں۔',
    hasReply: 'جواب دیا گیا',
    score5: 'بہت اچھا',
    score4: 'اچھا',
    score3: 'برا نہیں',
    score2: 'خراب',
    score1: 'بہت خراب',
    success: 'آپ کی فیڈبیک کا شکریہ',
    fail: 'جمع کروانے میں ناکام',
    pleaseScore: 'براہ کرم سروس کی درجہ بندی کریں',
    nofeedback: 'ابھی تک کوئی فیڈبیک نہیں',
    invalid:
      'آپ کی فیڈبیک کا شکریہ، ہم بہتری لانے کے لیے کام جاری رکھیں گے اور امید کرتے ہیں کہ آپ اچھا وقت گزاریں گے!',
    serviceHelp: 'اگر آپ کے پاس سوالات ہیں، تو براہ کرم یہاں کلک کریں اور کسٹمر سروس سے رابطہ کریں۔',

    reportTxt: 'رپورٹ',
    curseTxt: 'گالی',
    pornographyTxt: 'فحش مواد/بچوں کا تحفظ',
    advertiseTxt: 'تشہیر',
    Unsa: 'غیر قانونی صارف نام / دستخط / تصویر',
    Rnsa: 'غیر قانونی کمرہ نام / دستخط / تصویر',
    fbR: 'فیڈبیک',
    rpR: 'رپورٹ',

    operate: 'عملی مسائل',
    roomP: 'کمرہ کے مسائل',
    fr: 'فیڈبیک اور رپورٹ',

    picDesc: 'فیڈبیک تصویر',
    leaveInfo: 'براہ کرم اپنا واٹس ایپ، فون نمبر، یا ای میل درج کریں'
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/lang.js